export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TabRichieste.vue?vue&type=template&id=a0443638&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabRichieste.vue?vue&type=template&id=a0443638&scoped=true&
// module id = 898
// module chunks = 0